import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { catchError, retry, map, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EmailItineraryService {
  baseUrl = environment.baseUrl;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  }
  constructor(private http: HttpClient) { }
  emailItinerary(emailObj): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/EmailItinerary/SendEmailItinerary/' , emailObj, this.httpOptions).pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  emailIterniaryMulti(emailObj): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/EmailItinerary/EmailItineraryMultiple', emailObj).pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  

}
